<script lang="ts" setup>
const model = defineModel<any>();
</script>

<template>
    <textarea v-model="model" class="form-control"></textarea>
</template>
